import { IPresenceSlice, IPresenceStore } from '@/types'
import { TopicViewerEntry } from '@/types/notification'
import { PRESENCE_WINDOW_MS } from '@/utils/constants'

const initialState: IPresenceStore = {
  topicViewers: {},
}

export const createPresenceSlice = (set: any): IPresenceSlice => ({
  presence: initialState,
  // Upserts by sourceUserID so a viewer re-triggering topic_view (e.g. by
  // paginating notes) refreshes their timestamp instead of stacking a
  // duplicate avatar. Also evicts anything already past the presence window
  // right here on write — a viral/public gallery could otherwise accumulate
  // one entry per unique viewer for the entire life of the tab, since
  // useTopicViewers only filters at read time. If nothing will ever display
  // it, there's no reason to keep it in the store either.
  recordTopicView: (topicID: string, viewer: TopicViewerEntry) => {
    set((state: any) => {
      const existing: TopicViewerEntry[] = state.presence.topicViewers[topicID] || []
      const cutoff = Date.now() - PRESENCE_WINDOW_MS
      const stillRecent = existing.filter((v) => v.sourceUserID !== viewer.sourceUserID && v.viewedAt >= cutoff)
      return {
        presence: {
          ...state.presence,
          topicViewers: {
            ...state.presence.topicViewers,
            [topicID]: [viewer, ...stillRecent],
          },
        },
      }
    })
  },
  reset: () => set({ presence: initialState }),
})

export default createPresenceSlice
